import React, { FC } from 'react';
import { SearchFiltersRadioIcon } from '../../search-filters-radio/SearchFiltersRadioIcon';
import { SearchFiltersRadioLabel } from '../../search-filters-radio/SearchFiltersRadio';
import styles from './radio_input.module.scss';

type Props = {
  value: string;
  name: string;
  isSelected: boolean;
  handleClick: (event: React.MouseEvent<HTMLInputElement>) => void;
};

export const RadioInput: FC<Props> = ({
  value,
  handleClick,
  name,
  children,
  isSelected,
}) => (
  <SearchFiltersRadioLabel>
    <input
      type="radio"
      name={name}
      value={value}
      className={styles.input}
      onClick={handleClick}
    />
    <SearchFiltersRadioIcon isSelected={isSelected} />
    {children}
  </SearchFiltersRadioLabel>
);
